import { Component, createRef } from 'react'
import TopMenu from '../components/topMenu'
import moment from 'moment'
import QrReader from 'modern-react-qr-reader'
import withRouter from '../components/withRouter'
import Logo from '../images/GigLoca_Logo_Light.png'
import SmallCard from '../components/smallCard'
import Carousel from 'react-bootstrap/Carousel'
import Form from "react-bootstrap/Form"
import QRCode from 'qrcode.react'
import { API } from 'aws-amplify'
import { FaArrowLeft, FaUser, FaUserAltSlash } from 'react-icons/fa'
import { FcCancel, FcOk, FcPaid } from 'react-icons/fc'
import { MdPersonSearch } from 'react-icons/md'
import { BsQrCodeScan, BsEnvelopeCheck, BsCartX, BsInfoCircle } from 'react-icons/bs'
import './node.css'

class TixCheck extends Component {
    constructor(props) {
        super(props)

        this.state = {
            delay: 1000,
            data: null,
            scan: false,
            status: null,
            css: 'Small',
            msg: '',
            displayMsg: false,
            eid: null,
            scanner: true,
            events: [],
            event: null,
            tix: null,
            invite: '',
            info: [
                { id: 0, displayInfo: false, displayMsg: false, msg: 'To fetch an attendee\'s tickets:\n1. Perform attendee email search.\n2. Tap User Profile when retrieved.\n3. Tap ticket to perform Check-In.', dir: 'bottom', val: '0px' }
            ],
            userFailed: false,
            userPassed: false
        }
        this.handleResult = this.handleResult.bind(this)
        this.handleError = this.handleError.bind(this)
        this.handleOnPrefSelect = this.handleOnPrefSelect.bind(this)
        this.handleDisplaySettings = this.handleDisplaySettings.bind(this)
        this.handleOnNotificationsSelect = this.handleOnNotificationsSelect.bind(this)
        this.handleModeChange = this.handleModeChange.bind(this)
        this.handleEventSelect = this.handleEventSelect.bind(this)
    }

    CheckinStatus = createRef()

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            this.setState({ splash: false, bounce: true })
            setTimeout(() => {
                this.handleNavigate('main')
            }, 3000)
        } else {
            const gl = navigator.geolocation
            gl.getCurrentPosition(position => {
                this.props.onMyLoc({ lat: position.coords.latitude, lng: position.coords.longitude })
            }, err => {
                if (this.props.user && this.props.user.defaultLoc) {
                    this.props.onMyLoc(this.props.user.defaultLoc)
                }
            })
        }
    }

    scrollToRef = ref => {
        ref.current.scrollIntoView({
            behavior: 'smooth'
        })
    }

    handleNavigate(page) {
        this.props.onAddHistory(`/tixcheck`)
        const { navigate } = this.props
        navigate(`/${page}`)
    }

    handleBack() {
        this.props.onBack(this.state.refresh)
    }

    handleOnPrefSelect() {
        this.handleNavigate('profile')
    }

    handleDisplaySettings() {
        this.setState({ displaySettings: !this.state.displaySettings })
    }

    handleModeChange(mode) {
        if (mode) {
            if (mode === 'contactus' || mode === 'dyks') {
                this.handleNavigate(mode)
            } else if (mode === 'tix') {
                this.handleNavigate('tixcheck')
            } else if (mode !== 'fan') {
                this.props.setMode(mode)
                this.handleNavigate(`my/${mode === 'Venue' ? 'venues' : 'contributors'}`, true)
            } else {
                this.props.setMode(mode)
                this.handleNavigate('', true)
            }
        }
        this.setState({ displaySettings: false })
    }

    handleOnNotificationsSelect() {
        this.handleNavigate('notifications')
    }

    handleScan() {
        this.setState({ scan: !this.state.scan, status: null, data: null, css: 'Small' })
    }

    handleResult(result) {
        if (result) {
            this.setState({ scan: false })
            try {
                const ticket = JSON.parse(result)
                if (ticket.eid && ticket.tid && ticket.gid) {
                    API.put('lt', `tix/${ticket.eid}`, { body: { tid: ticket.tid, gid: ticket.gid, local: moment().format('YYYY-MM-DD HH:mm') } })
                        .then(resp => {
                            this.setState({ data: { ...resp }, eid: ticket.eid, status: resp.ticket.code ? 'code' : 'valid', css: 'Small' })
                            setTimeout(() => this.setState({ css: 'Big' }), 150)
                        })
                        .catch(e => {
                            this.setState({ data: e.response && e.response.data ? e.response.data : e.message, status: 'invalid', css: 'Small' })
                            setTimeout(() => this.setState({ css: 'Big' }), 150)
                            console.log(e)
                        })
                } else if (ticket.eid && ticket.checkin && ticket.email) {
                    //console.log(`tix/${ticket.eid}`, { body: { checkin: true, email: ticket.email, local: moment().format('YYYY-MM-DD HH:mm') } })
                    API.put('lt', `tix/${ticket.eid}`, { body: { checkin: true, email: ticket.email, local: moment().format('YYYY-MM-DD HH:mm') } })
                        .then(resp => {
                            this.setState({ data: { ...resp }, eid: ticket.eid, status: 'valid', css: 'Small' })
                            setTimeout(() => this.setState({ css: 'Big' }), 150)
                        })
                        .catch(e => {
                            this.setState({ data: e.response && e.response.data ? e.response.data : e.message, status: 'invalid', css: 'Small' })
                            setTimeout(() => this.setState({ css: 'Big' }), 150)
                            console.log(e)
                        })
                } else if (ticket.venuecheckin && ticket.email) {
                    console.log(`tix/${ticket.vid}`, { body: { venuecheckin: true, email: ticket.email, local: moment().format('YYYY-MM-DD HH:mm') } })
                    API.put('lt', `tix/${ticket.vid}`, { body: { venuecheckin: true, email: ticket.email, local: moment().format('YYYY-MM-DD HH:mm') } })
                        .then(resp => {
                            this.setState({ data: { ...resp }, eid: ticket.vid, status: 'valid', css: 'Small' })
                            setTimeout(() => this.setState({ css: 'Big' }), 150)
                        })
                        .catch(e => {
                            this.setState({ data: e.response && e.response.data ? e.response.data : e.message, status: 'invalid', css: 'Small' })
                            setTimeout(() => this.setState({ css: 'Big' }), 150)
                            console.log(e)
                        })
                } else {
                    this.setState({ data: { error: 'Invalid Ticket' }, status: 'invalid', css: 'Small' })
                    setTimeout(() => this.setState({ css: 'Big' }), 150)
                }
            }
            catch (e) {
                this.setState({ data: { error: 'Invalid Ticket' }, status: 'invalid', css: 'Small' })
                setTimeout(() => this.setState({ css: 'Big' }), 150)
            }
        }
    }

    handleManualCheckin(ticket) {
        if (ticket.eid && ticket.tid && ticket.gid) {
            API.put('lt', `tix/${ticket.eid}`, { body: { tid: ticket.tid, gid: ticket.gid, local: moment().format('YYYY-MM-DD HH:mm') } })
                .then(resp => {
                    this.setState({ data: { ...resp }, eid: ticket.eid, status: resp.ticket.code ? 'code' : 'valid', css: 'Small' })
                    setTimeout(() => {
                        this.setState({ css: 'Big' })
                        this.scrollToRef(this.CheckinStatus)
                    }, 150)
                })
                .catch(e => {
                    this.setState({ data: e.response && e.response.data ? e.response.data : e.message, status: 'invalid', css: 'Small' })
                    setTimeout(() => {
                        this.setState({ css: 'Big' })
                        this.scrollToRef(this.CheckinStatus)
                    }, 150)
                    console.log(e)
                })
        } else {
            this.setState({ data: { error: 'Invalid Ticket' }, status: 'invalid', css: 'Small' })
            setTimeout(() => {
                this.setState({ css: 'Big' })
                this.scrollToRef(this.CheckinStatus)
            }, 150)
        }
    }

    handleError(e) {
        console.log(e)
        //this.setState({ displayPost: false, post: '', isSaving: false, msg: e.message, displayMsg: true })
    }

    handleInfo(id) {
        let info = [...this.state.info]
        info.splice(id, 1, { ...this.state.info[id], displayMsg: !this.state.info[id].displayMsg, displayInfo: this.state.invite.length > 0 })
        this.setState({ info })
    }

    handleCodeConfirmed() {
        //if code is correct
        API.put('lt', `tix/${this.state.eid}`, { body: { tid: this.state.data.ticket.tid, gid: this.state.data.ticket.gid, code: true, local: moment().format('YYYY-MM-DD HH:mm') } })
            .then(resp => {
                this.setState({ data: { ...resp }, status: 'valid', css: 'Small' })
                setTimeout(() => this.setState({ css: 'Big' }), 150)
            })
            .catch(e => {
                this.setState({ data: e.response && e.response.data ? e.response.data : e.message, status: 'invalid', css: 'Small' })
                setTimeout(() => this.setState({ css: 'Big' }), 150)
                console.log(e)
            })
    }

    handleCodeFailed() {
        //if code is wrong
        this.setState({ data: 'Invalid Security Code', status: 'invalid', css: 'Small' })
        setTimeout(() => this.setState({ css: 'Big' }), 150)
    }

    handleGetEvents() {
        API.get('lt', `securityevents?security=true&local=${moment().format('YYYY-MM-DD HH:mm')}`)
            .then(resp => {
                this.setState({ events: resp.data, tix: null, status: null })
            })
            .catch(err => {
                if (err.response && err.response.status && err.response.status === 403) this.handleNavigate('main')
            })
    }

    handleSecurityModeChange() {
        const scanner = !this.state.scanner
        this.setState({ scanner, scan: false, status: null, tix: null })
        if (!scanner) this.handleGetEvents()
    }

    handleEventSelect(eid) {
        const idx = this.state.events.findIndex(e => e.id === eid)
        this.setState({ eid, event: this.state.events[idx] })
    }

    handleMsgOK() {
        this.setState({ msg: '', displayMsg: false })
    }

    handleChangeEmail = event => {
        let info = [...this.state.info]
        info.splice(0, 1, { ...this.state.info[0], displayInfo: event.target.value.length > 0 })
        this.setState({ [event.target.id]: event.target.value.replace(/[^a-zA-Z0-9-@._]/g, "").toLowerCase(), userFailed: false, userPassed: false, info })
    }

    handleCheckEmail() {
        if (this.getEmailIsValid()) {
            API.get('lt', `email?email=${this.state.invite}`)
                .then(resp => {
                    if (resp.data.verified) {
                        this.setState({ userFailed: false, userPassed: true, inviteImage: resp.data.image })
                    } else {
                        this.setState({ userFailed: true, userPassed: false, inviteImage: null })
                    }
                })
                .catch(err => {
                    console.log(err)
                    if (err.response && err.response.status && err.response.status === 403) {
                        this.handleNavigate('main')
                    } else this.setState({ userFailed: true, msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true })
                })
        } else this.setState({ userFailed: true })
    }

    handleFetchTix() {
        if (this.state.eid && this.state.invite && this.state.userPassed) {
            API.put('lt', `tix/${this.state.eid}`, { body: { email: this.state.invite, local: moment().format('YYYY-MM-DD HH:mm') } })
                .then(resp => {
                    this.setState({ tix: resp.tix, status: 'valid', css: 'Small' })
                    setTimeout(() => this.setState({ css: 'Big' }), 150)
                })
                .catch(e => {
                    this.setState({ msg: e.error || e.message, status: 'invalid', css: 'Small' })
                    setTimeout(() => this.setState({ css: 'Big' }), 150)
                    console.log(e)
                })
        }
    }

    getEmailIsValid() {
        return this.state.invite.length > 2 && this.state.invite.indexOf('@') > 0 && this.state.invite.indexOf('.') > 1
    }

    getBounce() {
        return <div className='Pref-Bounce'>
            <img src={Logo} className='Node-Logo' alt="GigLoca" />
            <div className='Node-Content'>Become part of the fun by Logging In or Joining GigLoca.</div>
        </div>
    }

    getInfo(id) {
        return <div className='Info-Container' style={{ [this.state.info[id].dir]: this.state.info[id].val }}>
            <div className='Info-Row Info-Text'>{this.state.info[id].msg}</div>
            <div className="Info-Flex-Wrap">
                <div className='Info-Button Info-Button-Save' onClick={() => this.handleInfo(id)}>Got It!</div>
            </div>
        </div>
    }

    getMessage() {
        return <div className='Node-Confirm'>
            <div className='Node-Row Confirm-Text'>{this.state.msg}</div>
            <div className="Node-Row Node-Flex-Wrap">
                <div className='Pref-Button Pref-Button-Save' onClick={() => this.handleMsgOK()}>OK</div>
            </div>
        </div>
    }

    getResponse() {
        return this.state.status === 'valid' || this.state.status === 'code' ? <div className='Node-Row'>
            <div className='Node-Row MyTix-Label'>{this.state.status === 'valid' ? 'Success' : 'Validate Code'}</div>
            {this.state.data && this.state.data.ticket && this.state.data.ticket.cat ? <div className='Node-Row MyTix-Label'>{this.state.data.ticket.cat}</div> : null}
            {this.state.data && this.state.data.ticket && this.state.data.ticket.label ? <div className='Node-Row MyTix-Label'>{this.state.data.ticket.label}</div> : null}
            {this.state.data && this.state.data.ticket && this.state.data.ticket.price ? <div className='Node-Row MyTix-Label'>${this.state.data.ticket.price}</div> : '$0.00'}
            {this.state.data && this.state.data.ticket && this.state.data.ticket.code ? <div className='Node-Row MyTix-Label' style={{ color: 'green', fontSize: '18pt', fontWeight: 'bold' }}>{this.state.data.ticket.code}</div> : null}
        </div> : <div className='Node-Row'>
            <div className='Node-Row MyTix-Label'>{this.state.data && this.state.data.error ? this.state.data.error : (this.state.data && this.state.data === 'Invalid Security Code' ? 'Invalid Security Code' : `Ticket Already Checked In`)}</div>
            {this.state.data && this.state.data.ticket && this.state.data.ticket.checkedTime ? <div className='Node-Row MyTix-Label'>{`at ${moment(this.state.data.ticket.checkedTime).format('lll')}`}</div> : null}
            {this.state.data && this.state.data.ticket && this.state.data.ticket.checkedBy ? <div className='Node-Row MyTix-Label'>by</div> : null}
            {this.state.data && this.state.data.ticket && this.state.data.ticket.checkedBy ? <div className='Node-Row Node-Flex-Wrap'><div className='Node-Flex'><div style={{ marginRight: '10px' }}>{this.state.data.ticket.checkedByImage ? <img className='My-User-Image' src={`https://localtalent-upload.s3.amazonaws.com/public/${this.state.data.ticket.checkedByImage}`} alt={'User'} /> : <div className='My-User-Image'><div style={{ marginTop: '-6px' }}><FaUser /></div></div>}</div><div className='My-Link-Text'>{this.state.data.ticket.checkedBy}</div></div></div> : null}
        </div>
    }

    getReader() {
        return <div className={window.innerWidth > 700 ? 'Node-Outer' : ''}>
            <div className='Node-Content-2'>
                {this.state.scan && <div className='Node-Row Reader-Container'>
                    <QrReader
                        delay={this.state.delay}
                        onScan={this.handleResult}
                        onError={this.handleError}
                        facingMode={"environment"}
                        style={{ width: '100%', height: '100%' }}
                    />
                </div>}
                <div className='Node-Row'>
                    <div className={`Reader-Button Reader-Button-${this.state.scan ? 'Cancel' : 'Scan'}`} onClick={() => this.handleScan()}>{this.state.scan ? 'Cancel' : 'Scan'}</div>
                </div>
                <div className='Node-Row MyTix-Label'>{this.state.data ? this.getResponse() : 'Ready...'}</div>
                {this.state.status ? <div className='Node-Row'>
                    <div className={`QR-Status QR-${this.state.css}`}>
                        {this.state.status === 'code' ? <div className='Node-Row Node-Flex-Spread'>
                            <div className='Pref-Button Pref-Button-Save' onClick={() => this.handleCodeConfirmed()}>Passed</div>
                            <div className='Pref-Button Pref-Cancel-Button' onClick={() => this.handleCodeFailed()}>Failed</div>
                        </div> : this.state.data ? (this.state.status === 'valid' ? <FcOk /> : <FcCancel />) : null}
                    </div>
                </div> : null}
            </div>
        </div>
    }

    getLookUp() {
        return <div className={window.innerWidth > 700 ? 'Node-Outer Node-Outer-Scroll' : 'Node-Outer-Scroll'}>
            <div className='Node-Row Node-Flex-Wrap'>
                {
                    this.state.events && this.state.events.map((e, eidx) => {
                        return <SmallCard key={`e-${eidx}`} type='event' data={e} onSelect={this.handleEventSelect} selected={this.state.event && this.state.event.id === e.id} />
                    })
                }
            </div>
            <div className='Node-Row Node-Flex-Wrap'><Carousel className='MyTix-Tix' interval={null} controls={false} slide={true} touch={true} activeIndex={this.state.activeIndex}>
                {this.state.tix && this.state.tix.map((t, tidx) => {
                    return <Carousel.Item key={`ci-${tidx}`}>
                        <div className='Node-Row'>
                            <div className='Node-Row MyTix-Label'>{t.cat}</div>
                            <div className='Node-Row Node-Flex-Wrap' style={{ cursor: 'pointer' }} onClick={() => this.handleManualCheckin({ eid: this.state.eid, tid: t.tid, gid: t.gid })}><QRCode size={256} value={`{"eid": "${this.state.id}", "tid": "${t.tid}", "gid": "${t.gid}"}`} /></div>
                            <div className='Node-Row MyTix-Label Node-Flex-Spread'><div>{t.label}</div><div>Ticket {t.id}</div></div>
                            <div className='Node-Row MyTix-Label'>{t.open ? 'Open' : 'Checked In'}</div>
                            <div className='Node-Row MyTix-Label Node-Flex-Wrap'>
                                <div>${t.price || '0.00'}</div>
                                {this.state.event.tickets && this.state.event.tickets.payment && <div style={{ fontSize: '16pt' }}>{t.pending ? <BsCartX /> : <FcPaid />}</div>}
                            </div>
                        </div>
                    </Carousel.Item>
                })}
            </Carousel>
            </div>
            <div className='Node-Row MyTix-Label'>{this.state.data ? this.getResponse() : 'Ready...'}</div>
            {this.state.status ? <div className='Node-Row'><div className={`QR-Status QR-${this.state.css}`}>
                {this.state.status === 'code' ? <div className='Node-Row Node-Flex-Spread'>
                    <div className='Pref-Button Pref-Button-Save' onClick={() => this.handleCodeConfirmed()}>Passed</div>
                    <div className='Pref-Button Pref-Cancel-Button' onClick={() => this.handleCodeFailed()}>Failed</div>
                </div> : this.state.data ? (this.state.status === 'valid' ? <FcOk /> : <FcCancel />) : null}
            </div></div> : null}
            {this.state.eid && this.state.event && <div className='Node-Row' style={{ paddingBottom: '20px' }}>
                <Form.Group controlId="invite" style={{ marginLeft: '5px', marginRight: '5px' }} className="form-group form-group-lg">
                    <div className='Node-Row Node-Flex'>
                        <Form.Label className='Pref-Label'>Retrieve Attendee's Tickets</Form.Label>
                        {this.state.info[0].displayInfo && <div className='Info-Icon' onClick={() => this.handleInfo(0)}><BsInfoCircle /></div>}
                        {this.state.info[0].displayMsg && this.getInfo(0)}
                    </div>
                    <div className='Node-Row Node-Flex'>
                        <Form.Control
                            placeholder="User Email"
                            type="email"
                            value={this.state.invite}
                            onChange={this.handleChangeEmail}
                            isValid={this.getEmailIsValid()}
                        />
                        <div className='My-Link-Icon' onClick={() => this.handleCheckEmail()}><MdPersonSearch /></div>
                        {this.state.userFailed ? <div className='My-Link-Icon' style={{ color: '#ff0000' }}><FaUserAltSlash /></div> : (this.state.userPassed ? <div style={{ marginLeft: '10px' }} onClick={() => this.handleFetchTix()}>{this.state.inviteImage ? <img className='My-User-Image' src={`https://localtalent-upload.s3.amazonaws.com/public/${this.state.inviteImage}`} alt={'User'} /> : <div className='My-User-Image'><div style={{ marginTop: '-6px' }}><FaUser /></div></div>}</div> : null)}
                    </div>
                </Form.Group>
            </div>}
            <div style={{ position: 'absolute', bottom: '-400px' }} ref={this.CheckinStatus}>&nbsp;</div>
        </div>
    }

    render() {
        //console.log(this.state)
        return (
            <div className='Node-Container Node-Check'>
                <TopMenu
                    mode='tix'
                    onMode={this.handleModeChange}
                    onPref={this.handleOnPrefSelect}
                    notifications={this.props.user ? (this.props.user.notifications && this.props.user.notifications.length > 0 ? this.props.user.notifications.length : true) : null}
                    onNotifications={this.handleOnNotificationsSelect}
                    user={this.props.user ? { firstName: this.props.user.firstName, image: this.props.user.image } : null}
                    onSettings={this.handleDisplaySettings}
                    displaySettings={this.state.displaySettings}
                    pref={null} />
                {
                    this.state.bounce ? this.getBounce() : <div>
                        <div style={{ position: 'relative', top: '0px' }} className='Node-Row Node-Flex-Spread'>
                            <div className='Node-Arrow' onClick={() => this.handleBack()}><div style={{ marginTop: '-13px' }}><FaArrowLeft /></div></div>
                            <div className='Node-Arrow' style={{ fontSize: '26pt' }} onClick={() => this.handleSecurityModeChange()}><div style={{ marginTop: '-7px' }}>{this.state.scanner ? <BsEnvelopeCheck /> : <BsQrCodeScan />}</div></div>
                        </div>
                        {this.state.scanner && this.getReader()}
                        {!this.state.scanner && this.getLookUp()}
                    </div>
                }
            </div>
        )
    }
}

export default withRouter(TixCheck)